module.exports = __webpack_public_path__ + "img/11-analises-todas-lista.71f7e290.png";